export enum TypeActeur {
    REPRESENTANT = "REPRESENTANT",
    INTERVENANT = "INTERVENANT",
    VALIDEUR = "VALIDEUR"
}
export class Destinataire {
	recipientId!: string;
	sentToDocusign!: boolean;
	email!: string;
	prenom!: string;
	nom!: string;
	typeActeur!: TypeActeur;
	allRoles: TypeActeur[] = [];
}